import { axiosInstance } from '@/http-common'

/**
 * Create a new asset group
 * @param data - Asset group data
 */
export async function createAssetGroup(data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/api/v1/asset-group', data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Update an existing asset group
 * @param id - Asset group ID
 * @param data - Updated asset group data
 */
export async function updateAssetGroup(id: number | string, data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset-group/${id}`, data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Delete an asset group
 * @param id - Asset group ID
 */
export async function deleteAssetGroup(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset-group/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Add or update location for asset group (with optional location image)
 * @param id - Asset group ID
 * @param formData - FormData containing location data and optional image
 */
export async function addAssetGroupLocation(id: number | string, formData: FormData): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`/api/v1/asset-group/${id}/location`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Add scheme (floor plan) to asset group
 * @param id - Asset group ID
 * @param formData - FormData containing scheme file, name, and description
 */
export async function addAssetGroupScheme(id: number | string, formData: FormData): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`/api/v1/asset-group/${id}/scheme`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Delete scheme from asset group
 * @param groupId - Asset group ID
 * @param schemeId - Scheme ID
 */
export async function deleteAssetGroupScheme(groupId: number | string, schemeId: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset-group/${groupId}/scheme/${schemeId}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Delete location image from asset group
 * @param groupId - Asset group ID
 * @param imageId - Location image ID
 */
export async function deleteAssetGroupLocationImage(groupId: number | string, imageId: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset-group/${groupId}/location/image/${imageId}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
